import React, { Component } from 'react';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import styled from 'styled-components';

const SortableQuestion = styled.div`
  border: 1px solid #efefef;
  padding: 5px;
  margin: 5px;
  border-radius: 5px;
  cursor: pointer;
`;

const SortableItem = SortableElement(({ value }) => <SortableQuestion>{value}</SortableQuestion>);

const SortableList = SortableContainer(({ items }) => (
  <div>
    {items.map((value, index) => (
      <SortableItem key={`item-${index}`} index={index} value={value.label} />
    ))}
  </div>
));

class SortableComponent extends Component {
  onSortEnd = ({ oldIndex, newIndex }) => {
    this.props.onChange({
      selectedQuestions: arrayMove(this.props.selectedQuestions, oldIndex, newIndex),
    });
  };

  render() {
    return <SortableList items={this.props.selectedQuestions} onSortEnd={this.onSortEnd} />;
  }
}

export default SortableComponent;



// WEBPACK FOOTER //
// ./src/components/forms/QuestionTemplateForm/SortableQuestions/index.js